import React from "react";

const today = new Date();
const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const submittedDate = `${MONTHS[today.getMonth()]} ${today.getDate()}, ${today.getFullYear()}`;

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap');

  .sub-root {
    background: #EDE3D7;
    min-height: 100vh;
    padding: 32px 16px;
    font-family: Georgia, serif;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .sub-wrap { width: 100%; max-width: 740px; }

  /* ── clinic bar — exact same as IntakeFormTerracotta ── */
  .tc-clinic-bar {
    display: flex; align-items: center; justify-content: space-between;
    background: white; border: 1px solid #D9C9B4; border-radius: 14px;
    padding: 16px 24px; margin-bottom: 18px; gap: 20px;
    transition: box-shadow .25s, transform .25s; cursor: default;
  }
  .tc-clinic-bar:hover { box-shadow: 0 6px 24px rgba(100,50,10,.10); transform: translateY(-2px); }
  .tc-clinic-left { display: flex; align-items: center; gap: 14px; }
  .tc-clinic-logo {
    width: 150px; height: 150px; background: #C2651A; border-radius: 10px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
    transition: background .2s, transform .2s;
  }
  .tc-clinic-bar:hover .tc-clinic-logo { background: #A0510E; transform: rotate(-4deg) scale(1.06); }
  .tc-clinic-logo-img {
    height: 150px; width: auto; max-width: 220px; min-width: 60px;
    object-fit: contain; border-radius: 10px; display: block; flex-shrink: 0;
  }
  .tc-clinic-name { font-size: 16px; color: #3D1F0A; letter-spacing: -.3px; }
  .tc-clinic-right { display: flex; flex-direction: column; gap: 5px; align-items: flex-end; }
  .tc-clinic-info {
    display: flex; align-items: center; gap: 6px;
    font-size: 12px; color: #5C3A1E; font-family: 'DM Sans', sans-serif;
    font-weight: 500; transition: color .15s;
  }
  .tc-clinic-info:hover { color: #C2651A; }

  /* ── confirmation card ── */
  .sub-card {
    background: white;
    border: 1px solid #D9C9B4;
    border-radius: 16px;
    padding: 52px 40px;
    text-align: center;
    max-width: 500px;
    width: 100%;
    margin: 0 auto;
    animation: subFadeUp .4s ease both;
  }

  @keyframes subFadeUp {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: none; }
  }

  .sub-icon-wrap {
    width: 76px; height: 76px;
    background: #FFF1E6; border-radius: 50%; border: 2px solid #C2651A;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 24px;
    animation: subPopIn .5s cubic-bezier(.34,1.56,.64,1) .15s both;
  }

  @keyframes subPopIn {
    from { opacity: 0; transform: scale(0.5); }
    to   { opacity: 1; transform: scale(1); }
  }

  .sub-title { font-size: 24px; color: #3D1F0A; letter-spacing: -.5px; margin-bottom: 12px; }

  .sub-body {
    font-size: 13.5px; color: #7A5230; line-height: 1.75;
    font-family: 'DM Sans', sans-serif; font-weight: 500;
  }

  .sub-divider { height: 0.5px; background: #D9C9B4; margin: 24px 0; }

  .sub-meta { display: flex; justify-content: center; gap: 32px; }

  .sub-meta-item { display: flex; flex-direction: column; align-items: center; gap: 4px; }

  .sub-meta-label {
    font-size: 10px; font-weight: 600; letter-spacing: .12em;
    text-transform: uppercase; color: #C2651A;
    font-family: 'DM Sans', sans-serif;
  }

  .sub-meta-val {
    font-size: 13px; color: #3D1F0A;
    font-family: 'DM Sans', sans-serif; font-weight: 500;
  }

  .sub-note {
    margin-top: 24px; font-size: 12px; color: #A07050;
    font-family: 'DM Sans', sans-serif; font-style: italic;
  }

  @media(max-width: 768px) {
    .tc-clinic-logo, .tc-clinic-logo-img { height: 104px; }
    .tc-clinic-logo { width: 104px; }
    .tc-clinic-logo-img { max-width: 160px; }
  }

  @media(max-width: 580px) {
    .tc-clinic-bar { flex-direction: column; align-items: flex-start; }
    .tc-clinic-right { align-items: flex-start; }
    .sub-card { padding: 36px 20px; }
    .sub-meta { gap: 16px; }
  }

  @media(max-width: 400px) {
    .tc-clinic-logo, .tc-clinic-logo-img { height: 80px; }
    .tc-clinic-logo { width: 80px; }
    .tc-clinic-logo-img { max-width: 130px; }
  }
`;

const IconHeartRate = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="2,12 6,12 8,6 10,18 12,10 14,14 16,12 22,12" />
  </svg>
);

const IconPin = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C2651A" strokeWidth="2" strokeLinecap="round">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
    <circle cx="12" cy="9" r="2.5"/>
  </svg>
);

const IconPhone = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C2651A" strokeWidth="2" strokeLinecap="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);

export default function SubmittedStep({ logo, orgInfo }) {
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <div className="sub-root">
        <div className="sub-wrap">

          {/* ── Clinic bar — same as IntakeFormTerracotta ── */}
          <div className="tc-clinic-bar">
            <div className="tc-clinic-left">
              {logo
                ? <img src={logo} alt="Clinic logo" className="tc-clinic-logo-img" />
                : <div className="tc-clinic-logo"><IconHeartRate /></div>
              }
              <div className="tc-clinic-name">{orgInfo?.name}</div>
            </div>
            <div className="tc-clinic-right">
              {orgInfo?.address && (
                <div className="tc-clinic-info"><IconPin /> {orgInfo.address}</div>
              )}
              {orgInfo?.contactNum && (
                <div className="tc-clinic-info"><IconPhone /> {orgInfo.contactNum}</div>
              )}
            </div>
          </div>

          {/* ── Confirmation card ── */}
          <div className="sub-card">

            <div className="sub-icon-wrap">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                <circle cx="18" cy="18" r="17" stroke="#C2651A" strokeWidth="1.5"/>
                <polyline
                  points="10,18 15,23 26,12"
                  stroke="#C2651A"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <div className="sub-title">Form submitted</div>
            <div className="sub-body">
              Thank you. Your intake form has been received.<br />
              Your clinic will review it before your appointment.
            </div>

            <div className="sub-divider" />

            <div className="sub-meta">
              <div className="sub-meta-item">
                <span className="sub-meta-label">Status</span>
                <span className="sub-meta-val">Received ✓</span>
              </div>
              <div className="sub-meta-item">
                <span className="sub-meta-label">Submitted</span>
                <span className="sub-meta-val">{submittedDate}</span>
              </div>
              <div className="sub-meta-item">
                <span className="sub-meta-label">Action required</span>
                <span className="sub-meta-val">None</span>
              </div>
            </div>

            <div className="sub-note">You may safely close this window.</div>

          </div>
        </div>
      </div>
    </>
  );
}